'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.siteHeader = twentyninetimes.siteHeader || function () {

	function init() {
		header_scroll_class_toggle();
	}

   function header_scroll_class_toggle() {
        // Hide Header on on scroll down
        var didScroll,
            lastScrollTop = 0,
            navbar = document.getElementById('js-site-header'),
            navbarHeight = navbar.clientHeight;

        document.addEventListener('scroll', function (e) {
            didScroll = true;
        });

        setInterval(function() {
            if ( didScroll ) {
                hasScrolled();
                didScroll = false;
            }
        }, 100);

        function hasScrolled() {
            var scroll_top = window.scrollY         
            
            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if ( scroll_top > navbarHeight ) {
                // Scroll Down
                navbar.classList.add('scrolled');
                return;
            } else {
                navbar.classList.remove('scrolled');
            }
            
            lastScrollTop = scroll_top;
        }
    }

	return {
		init : init
	};

}();